import { FormattedMessage } from 'react-intl'
import ResortPricing from '../resort/ResortPricing'
import { PropTypes } from 'prop-types'

CheckoutResortStep1.propTypes = {
  shopSlug: PropTypes.string.isRequired,
  shopId: PropTypes.string.isRequired,
  shopTitle: PropTypes.string.isRequired,
  availablePackageKinds: PropTypes.array.isRequired,
  hasStudentCourses: PropTypes.bool.isRequired,
  isFixedPackage: PropTypes.bool.isRequired,
}

export default function CheckoutResortStep1({
  shopSlug,
  shopId,
  shopTitle,
  availablePackageKinds,
  hasStudentCourses,
  isFixedPackage,
}) {
  return (
    <div className='main-content'>
      <h2 className='step-title'>
        <span className='number'>1</span>
        <FormattedMessage
          id='select_yout_package'
          defaultMessage='Select your package'
        />
      </h2>
      <ResortPricing
        slug={shopSlug}
        id={shopId}
        isCheckout
        title={shopTitle}
        availablePackageKinds={availablePackageKinds}
        hasStudentCourses={hasStudentCourses}
        isFixedPackage={isFixedPackage}
        includeFreeDiveInsurance
      />
    </div>
  )
}
